/**
 * useTypeFieldsSaveGuard — blokada zapisu karty dokumentu, dopóki trwa wczytywanie pól typu.
 *
 * Bez stanów pól typu karta nie wie, które pola dodatkowe są „nie dotyczy”, a które wymagane, więc
 * zapis w tym oknie mógłby pominąć sprawdzenie wymaganych pól. Wspólne dla wszystkich 7 klas
 * dokumentów: karta przekazuje `isLoading` z `useDocumentTypeFields` i na początku zapisu woła
 * zwróconą funkcję — `true` = zapis wstrzymany (z komunikatem). Błąd odczytu pól typu NIE blokuje
 * (`isLoading` jest wtedy `false`): karta działa jak bez typu, a o zapisie rozstrzyga serwer.
 */

import { useTranslation } from 'react-i18next';

import { useToast } from '@/contexts/ToastContext';

export function useTypeFieldsSaveGuard(typeFieldsLoading: boolean): () => boolean {
  const { t } = useTranslation();
  const toast = useToast();

  return () => {
    if (!typeFieldsLoading) return false;
    toast.show({
      variant: 'warning',
      title: t('tenant.documents.typeFields.stillLoading'),
    });
    return true;
  };
}
